export const adaptCentroReferencia = (centro) => {
    return {
        cod_institucion: centro?.cod_Institucion,
        nombre: centro?.nombre
    }
}

export const adaptCentroReferenciaArray = (
    centros
) => {
    return structuredClone(centros?.institucionesByPaciente?.items)
        ?.map(centro => adaptCentroReferencia(centro));
}